const e={get:(e,t="")=>t,set(){},remove(){},each(){},clearAll(){}},t=Object.assign({setWithExpiration(){}},e);export{t as defaultFallbackCookieStorage,e as defaultFallbackStorage};
//# sourceMappingURL=fallback.js.map
